/**
 * Tools for rendering collections of Articles.
 *
 * @module
 */
import * as React from 'react';
import { Group, Loop } from './articlesGroup';
import useArticles from '../hooks/useArticles';
export { Group, Loop };
/**
 * Either prints out or passes (in the case of a render prop as children) the total number of articles in a given category.
 *
 * - If no `categoryId`  provided, will use the current category context.
 */
export const TotalCount = ({ children, categoryId }) => {
    const { totalCount } = useArticles(categoryId);
    if (totalCount == null)
        return null;
    if (children)
        return React.createElement(React.Fragment, null, children({ totalCount }));
    return React.createElement(React.Fragment, null, totalCount);
};
TotalCount.displayName = 'Articles.TotalCount';
//# sourceMappingURL=articles.js.map